import { http } from '../services';

class SalaService {
    salaForm() {
        return http.get('/salas/form');
    }

    // getSalas() {
    //     return http.get('/salas');
    // }

    async getAll({
        pageIndex,
        rowsPerPage,
        columnSort,
        orderSort,
        searchIndex,
        searchText,
        searchOperator,
    }) {
        return http.get('/salas', {
            pageIndex,
            rowsPerPage,
            columnSort,
            orderSort,
            searchIndex,
            searchText,
            searchOperator,
        });
    }

    async getCount({ searchIndex, searchText, searchOperator }) {
        return http.get('/salas/count', {
            searchIndex,
            searchText,
            searchOperator,
        });
    }

    getSala(codigo) {
        return http.get(`/salas/${codigo}`);
    }

    getSalasApresentacao(projeto) {
        return http.get(`/salas-apresentacao/${projeto}`);
    }

    save(sala) {
        return http.post('/salas', sala);
    }

    update(sala) {
        return http.put('/salas', sala);
    }

    delete(sala) {
        return http.delete('/salas', sala);
    }
}

const salaService = new SalaService();
export default salaService;
